import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ContentSideBySideCustom,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  Trust,
} from "../components/Hero";
import { Link, Navigate, useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SchoolIcon from "@mui/icons-material/School";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GroupsIcon from "@mui/icons-material/Groups";
import ChildFriendlyIcon from "@mui/icons-material/ChildFriendly";
import { Grid } from "@mui/material";
import axios from "axios";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { alertMessage } from "../actions/auth";
import TextField from "@mui/material/TextField";
import Lottie from "react-lottie";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PublishIcon from "@mui/icons-material/Publish";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";

import { FeatureCard } from "../components/Hero";
import { FeatureCardSmall } from "../components/Hero";
import CellTowerIcon from "@mui/icons-material/CellTower";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WorkIcon from "@mui/icons-material/Work";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BuildIcon from "@mui/icons-material/Build";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PersonIcon from "@mui/icons-material/Person";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import { Collage2, OurProcess } from "./Sections";

// Updated API URL
const API_URL = "https://api.cgtsol.in/v1/";

export default function Careers() {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    fetchPublicPositions();
  }, [currentPage]);

  const fetchPublicPositions = () => {
    setLoading(true);
    axios
      .post(API_URL + "position/public", {
        limit:10,
        page: currentPage,
        categoryType: "positionType",
      })
      .then((res) => {
        console.log(res.data);
        setPositions(res.data.positions || []);
        setTotalPages(res.data.totalPages || 0);
        setTotalCount(res.data.totalCount || 0);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching positions:", err);
        setPositions([]);
        setLoading(false);
      });
  };

  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [jobName, setJobName] = useState("");
  const [jobLink, setJobLink] = useState("");
  const [experience, setExperience] = useState("");
  const [selectedPosition, setSelectedPosition] = useState(null);

  const [value, setValue] = React.useState("1");

  const [selectedFile, setSelectedFile] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [jobId, setJobId] = useState("");

  const dispatch = useDispatch();

  function onFileChange(event) {
    setSelectedFile(event.target.files[0]);
    setOpen2(true);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function onFileUpload() {
    setIsSubmitting(true);
    const formData = new FormData();

    formData.append("resume", selectedFile, selectedFile.name);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phoneNumber", phoneNumber);
    formData.append("description", description);
    formData.append("experience", experience);
    formData.append("positionId", jobId);

    // Submit to career applications API
    axios
      .post(API_URL + "career-applications/submit", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setIsSubmitting(false);
        dispatch(
          alertMessage(
            "SUCCESS",
            "Application Submitted!",
            `Your application for ${jobName} has been successfully submitted. We will review your application and get back to you soon.`
          )
        );

        // Close modals and reset form
        setOpen2(false);
        setOpen(false);
        setName("");
        setEmail("");
        setPhoneNumber("");
        setDescription("");
        setExperience("");
        setSelectedFile("");
        setJobName("");
        setJobId("");
        document.getElementById("contained-button-file").value = "";
      })
      .catch((error) => {
        setIsSubmitting(false);
        const errorMessage =
          error.response?.data?.message ||
          "There was an error submitting your application. Please try again.";
        dispatch(alertMessage("ERROR", "Submission Failed", errorMessage));
      });
  }

  function fileData() {
    if (selectedFile) {
      return (
        <div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpen2(false)}
                style={{
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                }}
              />
            </IconButton>
          </div>
          <h2>File Details:</h2>
          <p>File Name: {selectedFile.name}</p>
          <p>File Type: {selectedFile.type}</p>

          <br></br>
          <br></br>
          {selectedFile.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUpload()}
                style={{
                  width: "100%",
                  fontSize: "15px",
                  height: "35px",
                  backgroundColor: themeStyle.primaryColor,
                }}
                disabled={isSubmitting}
              >
                <PublishIcon />
                &nbsp;&nbsp;
                {isSubmitting ? "SUBMITTING..." : "SUBMIT APPLICATION"}
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUpload()}
                style={{
                  width: "100%",
                  fontSize: "15px",
                  height: "35px",
                  backgroundColor: themeStyle.primaryColor,
                }}
              >
                <PublishIcon />
                &nbsp;&nbsp;APPLY NOW
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Apply button</h4>
        </div>
      );
    }
  }

  const handleApplyClick = (position) => {
    setSelectedPosition(position);
    setJobName(position.positionName);
    setJobId(position._id);
    setOpen(true);
  };

  const formatSkills = (skillSet) => {
    if (!skillSet || skillSet.length === 0) return "Not specified";

    return skillSet.map((skill, index) => (
      <Chip
        key={index}
        label={`${skill.skill} (${skill.totalYearsOfExperience}y)`}
        size="small"
        style={{
          margin: "2px",
          backgroundColor: "#f0f0f0",
          fontSize: "12px",
        }}
      />
    ));
  };

  const formatPrimarySkills = (primarySkillSet) => {
    if (!primarySkillSet)
      return (
        <span style={{ fontSize: "12px", color: "#666" }}>Not specified</span>
      );

    // Handle different data types and ensure we split properly
    let skillsArray = [];

    if (Array.isArray(primarySkillSet)) {
      // If it's an array, process each item
      skillsArray = primarySkillSet
        .flatMap((item) => {
          if (typeof item === "string" && item.includes(",")) {
            // Split comma-separated strings within array items
            return item
              .split(",")
              .map((skill) => skill.trim())
              .filter((skill) => skill.length > 0);
          }
          return typeof item === "string" ? item.trim() : String(item).trim();
        })
        .filter((skill) => skill.length > 0);
    } else if (typeof primarySkillSet === "string") {
      // Split by comma, semicolon, or pipe and clean up
      skillsArray = primarySkillSet
        .split(/[,;|]/)
        .map((skill) => skill.trim())
        .filter((skill) => skill.length > 0);
    } else {
      skillsArray = [String(primarySkillSet).trim()];
    }

    // Remove duplicates
    skillsArray = [...new Set(skillsArray)];

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "4px",
          maxWidth: "250px",
        }}
      >
        {skillsArray.map((skill, index) => (
          <Chip
            key={index}
            label={skill}
            size="small"
            variant="outlined"
            sx={{
              bgcolor: "#e3f2fd",
              borderColor: "#0063cc",
              color: "#0063cc",
              fontSize: "11px",
              height: "22px",
              fontWeight: "500",
              border: "1px solid #b3d9ff",
              borderRadius: "16px",
              margin: "1px",
              "&:hover": {
                bgcolor: "#bbdefb",
                borderColor: "#1976d2",
              },
            }}
          />
        ))}
      </div>
    );
  };

  const state = useSelector((state) => state);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open2}
          onClose={() => setOpen2(false)}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open2}>
            <div
              style={{
                position: "absolute",
                top: "50%",
                backgroundColor: themeStyle.backgroundColor,
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                padding: "20px",
              }}
            >
              {fileData()}
            </div>
          </Fade>
        </Modal>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div
              style={{
                borderRadius: "25px",
                position: "absolute",
                top: "50%",
                backgroundColor: "white",
                left: "50%",
                transform: "translate(-50%, -50%)",
                padding: "20px",
                width: state.auth.isMobile ? "100vw" : "60vw",
                maxHeight: "90vh",
                overflow: "auto",
              }}
            >
              <h2 style={{ marginBottom: "10px", textAlign: "center" }}>
                Apply for {jobName}
              </h2>

              <form style={{ padding: "15px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid " + themeStyle.primaryColor,
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: 600,
                            opacity: 1,
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="name"
                      autoComplete="name"
                      autoFocus
                      placeholder="Name *"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "2px solid " + themeStyle.primaryColor,
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: 600,
                            opacity: 1,
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="phonenumber"
                      autoComplete="phonenumber"
                      autoFocus
                      placeholder="Phone number *"
                      value={phoneNumber}
                      onChange={(e) => {
                        setPhoneNumber(e.target.value);
                      }}
                    />
                  </Grid>
                </Grid>

                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid " + themeStyle.primaryColor,
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  placeholder="E-mail *"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    height: "400",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid " + themeStyle.primaryColor,
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="description"
                  autoComplete="description"
                  autoFocus
                  placeholder="Work history (Years and Company)"
                  value={experience}
                  onChange={(e) => {
                    setExperience(e.target.value);
                  }}
                />

                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    height: "400",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid " + themeStyle.primaryColor,
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="description"
                  autoComplete="description"
                  multiline
                  rows={4}
                  autoFocus
                  placeholder="Description of your past projects/current position *"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    dispatch({
                      type: "NAV_COLOR",
                      payload: { navColor: "#444", navOpacity: 1 },
                    });
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <label
                    style={{ width: "100%" }}
                    htmlFor="contained-button-file"
                  >
                    <input
                      style={{ display: "none" }}
                      id="contained-button-file"
                      type="file"
                      onChange={(e) => onFileChange(e)}
                    />

                    <Button
                      style={{
                        width: "100%",
                        fontSize: "15px",
                        height: "55px",
                        textAlign: "center",
                        backgroundColor: themeStyle.primaryColor,
                      }}
                      variant="contained"
                      component="span"
                    >
                      <h4>Upload Resume and Submit Application</h4>
                    </Button>
                  </label>
                </div>
              </form>
            </div>
          </Fade>
        </Modal>

        <div
          style={{
            padding: state.auth.isMobile ? "75px" : "100px",
            width: state.auth.isMobile ? "125vw" : "100vw",
            height: state.auth.isMobile ? "25vh" : "100vh",
            marginBottom: state.auth.isMobile ? "-200x" : "0px",
            backgroundColor: "white",
          }}
        >
          <Grid
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={10}
              sm={10}
              style={{
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "start",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <div
                style={{
                  marginTop: "175px",
                  marginTop: state.auth.isMobile ? "50px" : "180px",
                  marginLeft: state.auth.isMobile ? "-50px" : "0px",
                  fontSize: state.auth.isMobile ? "40px" : "45px",
                  color: "black",
                  zIndex: 999,
                  fontWeight: 600,
                }}
              >
                Careers at CGT Solutions
              </div>

              {!state.auth.isMobile ? (
                <div
                  style={{
                    borderBottom: "2px solid black",
                    width: "100%",
                    margin: "50px 0px 50px 0px",
                    zIndex: 999,
                  }}
                ></div>
              ) : (
                ""
              )}
              <div
                style={{
                  fontSize: "25px",
                  color: "black",
                  zIndex: 999,
                  marginTop: state.auth.isMobile ? "20px" : "0px",
                  marginLeft: state.auth.isMobile ? "-50px" : "0px",
                }}
              >
                Secure and managed cloud solutions that drive outcome-based
                modernization{" "}
              </div>
            </Grid>

            {!state.auth.isMobile ? (
              <Grid
                item
                md={6}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  height: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <div
                  style={{
                    borderLeft: "100vh solid transparent",
                    borderRight: "100vh solid transparent",
                    borderBottom: "100vh solid #090979",
                    position: "absolute",
                    // transform: "rotate(deg)",
                    right: "-90vh",
                    top: "-10vh",
                  }}
                >
                  <div
                    style={{
                      color: "white",
                      fontWeight: "600",
                      textAlign: "right",
                      fontSize: "50px",
                      position: "absolute",
                      top: "45vh",
                      right: "0vh",
                      borderBottom: "5px dotted white",
                      paddingBottom: "40px",
                    }}
                  >
                    Progress with purpose
                  </div>
                </div>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </div>
        <div style={{ height: "100px" }} />
        <ContentSideBySideInv
          title="Why Work with Us?"
          subtitle={
            <ul style={{ marginLeft: "-40px" }}>
              <strong>Cutting-Edge Skill Development:</strong> : Immerse
              yourself in hands-on experiences with advanced tools and
              technologies, boosting your technical expertise and marketability.
              <br />
              <br />
              <strong>Creative and Innovative Projects:</strong>Engage in
              diverse, high-impact projects that let you showcase and expand
              your creativity.
              <br />
              <br />
              <strong>Professional Growth Opportunities:</strong> Benefit from
              access to training, workshops, and mentorship programs designed to
              help you stay ahead in the competitive IT solutions and staffing
              industry.
            </ul>
          }
          image={
            <img
              style={{ width: "100%", marginTop: "15px" }}
              src={require("../img/444.jpg")}
            />
          }
        />
        <SpacerV height={"100px"} />

        <div
          style={{
            borderRadius: "25px",
            fontSize: state.auth.isMobile ? "30px" : "40px",
            color: themeStyle.primaryColor,
            fontWeight: 600,
            backgroundColor: "white",
            paddingBottom: "50px",
          }}
        >
          Current Openings
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: "50px" }}>
            <div>Loading positions...</div>
          </div>
        ) : (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <TableContainer
              component={Paper}
              style={{ width: state.auth.isMobile ? "100%" : "90%" }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{
                        fontWeight: 600,
                        width: "140px",
                        minWidth: "140px",
                      }}
                    >
                      Client
                    </TableCell>
                    <TableCell
                      style={{
                        fontWeight: 600,
                        width: "200px",
                        minWidth: "200px",
                      }}
                    >
                      Position
                    </TableCell>
                    <TableCell
                      style={{
                        fontWeight: 600,
                        width: "100px",
                        minWidth: "100px",
                      }}
                    >
                      Experience
                    </TableCell>
                    <TableCell
                      style={{
                        fontWeight: 600,
                        width: "120px",
                        minWidth: "120px",
                      }}
                    >
                      Work Mode
                    </TableCell>
                    <TableCell
                      style={{
                        fontWeight: 600,
                        width: "280px",
                        minWidth: "280px",
                      }}
                    >
                      Skills
                    </TableCell>
                    <TableCell
                      style={{
                        fontWeight: 600,
                        width: "130px",
                        minWidth: "130px",
                      }}
                    >
                      Location
                    </TableCell>
                    <TableCell
                      style={{
                        fontWeight: 600,
                        width: "90px",
                        minWidth: "90px",
                      }}
                    >
                      Apply
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {positions.length > 0 ? (
                    positions.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ fontSize: "14px", width: "140px" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <BusinessIcon
                              style={{ marginRight: "2px", fontSize: "16px" }}
                            />
                            {row.endClient || "Company"}
                          </div>
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            width: "200px",
                          }}
                        >
                          {row.positionName}
                        </TableCell>
                        <TableCell style={{ fontSize: "14px", width: "100px" }}>
                          {row.totalExperience || "Not specified"}
                        </TableCell>
                        <TableCell style={{ fontSize: "14px", width: "120px" }}>
                          <Chip
                            label={row.workMode?.name || "Not specified"}
                            size="small"
                            style={{ backgroundColor: "#f3e5f5" }}
                          />
                        </TableCell>
                        <TableCell
                          style={{
                            fontSize: "14px",
                            maxWidth: "280px",
                            width: "280px",
                            padding: "8px",
                          }}
                        >
                          {formatPrimarySkills(row.primarySkillSet)}
                        </TableCell>
                        <TableCell style={{ fontSize: "14px", width: "130px" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <LocationOnIcon
                              style={{ marginRight: "5px", fontSize: "16px" }}
                            />
                            {row.location || "Not specified"}
                          </div>
                        </TableCell>
                        <TableCell style={{ width: "90px" }}>
                          <Button
                            onClick={() => handleApplyClick(row)}
                            style={{
                              width: "80px",
                              height: "35px",
                              fontSize: "12px",
                              backgroundColor: themeStyle.primaryColor,
                              color:
                                state.auth.theme == "dark"
                                  ? themeStyleDark.primaryButtonTextColor
                                  : themeStyle.primaryButtonTextColor,
                            }}
                            variant="contained"
                          >
                            Apply
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        style={{ textAlign: "center", padding: "50px" }}
                      >
                        <div>
                          <PersonSearchIcon
                            style={{ fontSize: "48px", color: "#ccc" }}
                          />
                          <div
                            style={{
                              marginTop: "10px",
                              fontSize: "18px",
                              color: "#666",
                            }}
                          >
                            No positions available at the moment
                          </div>
                          <div
                            style={{
                              marginTop: "5px",
                              fontSize: "14px",
                              color: "#999",
                            }}
                          >
                            Please check back later for new opportunities
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              gap: "10px",
            }}
          >
            <Button
              disabled={currentPage === 0}
              onClick={() => setCurrentPage(currentPage - 1)}
              style={{
                backgroundColor:
                  currentPage === 0 ? "#ccc" : themeStyle.primaryColor,
                color: "white",
              }}
            >
              Previous
            </Button>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0 20px",
                fontSize: "16px",
              }}
            >
              Page {currentPage + 1} of {totalPages}
            </div>

            <Button
              disabled={currentPage >= totalPages - 1}
              onClick={() => setCurrentPage(currentPage + 1)}
              style={{
                backgroundColor:
                  currentPage >= totalPages - 1
                    ? "#ccc"
                    : themeStyle.primaryColor,
                color: "white",
              }}
            >
              Next
            </Button>
          </div>
        )}

        <SpacerV height={"100px"} />
        <SpacerV height={"100px"} />
        <OurProcess
          invert
          step1={"Define Your Career Goals and Growth Path"}
          step1description={
            "We start by understanding your career aspirations and aligning them with opportunities within our organization. Whether you're looking to grow as a developer, designer, or leader, we help you define clear goals and create a personalized growth plan. Our mentorship programs and career development workshops ensure you have the support you need to succeed."
          }
          step2={"Collaborate and Innovate in a Dynamic Environment"}
          step2description={
            "Join a team that values collaboration and innovation. Work alongside talented professionals on cutting-edge projects that challenge and inspire you. Our open and inclusive culture encourages creativity, knowledge sharing, and out-of-the-box thinking, helping you grow both personally and professionally."
          }
          step3={"Access Learning and Development Opportunities"}
          step3description={
            "We invest in your growth by providing access to training programs, certifications, and workshops. Whether you want to learn a new technology, improve your leadership skills, or stay ahead in your field, we offer the resources and support to help you achieve your goals. Continuous learning is at the heart of our culture."
          }
          step4={"Thrive in a Supportive and Inclusive Workplace"}
          step4description={
            "At our company, we celebrate diversity and foster an inclusive environment where everyone feels valued and respected. From flexible work policies to wellness programs, we prioritize your well-being and work-life balance. Join us and be part of a workplace that empowers you to thrive and make a meaningful impact."
          }
        />
        <div
          style={{
            paddingTop: "50px",
            paddingBottom: "100px",
          }}
        >
          <TabContext value={value}>
            {!state.auth.isMobile ? (
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "50px",
                  background: "transparent",
                  maxWidth: "100vw",
                }}
              >
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    label="Growth"
                    value="1"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Work-Life Balance"
                    value="2"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Innovative Culture"
                    value="3"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Learning "
                    value="4"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                  <Tab
                    label="Inclusive Environment"
                    value="5"
                    style={{ fontSize: "22px", color: "black" }}
                  />
                </TabList>
              </Box>
            ) : (
              <div style={{ marginBottom: "-100px" }} />
            )}
            <TabPanel value="1">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                subtitleFontSize={"20px"}
                title="Unlock Your Potential with Growth Opportunities"
                subtitle="At our company, we believe in nurturing talent and providing clear career progression paths. Whether you're starting your career or looking to take the next step, we offer mentorship programs, leadership training, and opportunities to work on cutting-edge projects. Grow with us and achieve your professional goals while making a meaningful impact."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={
                      "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    }
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="2">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                subtitleFontSize={"20px"}
                title="Achieve Work-Life Balance with Flexible Policies"
                subtitle="We understand the importance of balancing work and personal life. Enjoy flexible working hours, remote work options, and generous paid time off. Our supportive policies ensure you can thrive both professionally and personally, making your time with us fulfilling and stress-free."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={
                      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    }
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="3">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleFontSize={"20px"}
                subtitleColor={"#222"}
                title="Be Part of an Innovative and Collaborative Culture"
                subtitle="Join a team that values creativity, collaboration, and innovation. We encourage out-of-the-box thinking and provide the tools and resources you need to bring your ideas to life. Work alongside talented professionals in a dynamic environment where your contributions matter."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={
                      "https://images.unsplash.com/photo-1559136656-3db4bf6c35f8?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    }
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="4">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                subtitleFontSize={"20px"}
                title="Continuous Learning and Professional Development"
                subtitle="We invest in your growth by offering access to training programs, workshops, and certifications. Stay ahead in your field with opportunities to learn new skills and technologies. Our commitment to your development ensures you're always growing and evolving in your career."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={
                      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    }
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="5">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"black"}
                subtitleColor={"#222"}
                subtitleFontSize={"20px"}
                title="Join an Inclusive and Diverse Workplace"
                subtitle="We celebrate diversity and are committed to creating an inclusive environment where everyone feels valued and respected. Our team is made up of individuals from different backgrounds, cultures, and perspectives, fostering a rich and collaborative workplace culture."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={
                      "https://images.unsplash.com/photo-1560264280-88b68371db39?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    }
                  ></img>
                }
              />
            </TabPanel>
          </TabContext>
        </div>
        <div
          className="anigrad"
          style={{
            width: "100%",
            padding: "50px",
          }}
        >
          <div
            style={{
              borderRadius: "25px",
              fontSize: state.auth.isMobile ? "30px" : "40px",
              color: "white",
              fontWeight: 600,
              paddingTop: "50px",
            }}
          >
            Benefits of Joining Us
          </div>
          <div
            style={{
              borderRadius: "25px",
              fontSize: "22px",
              color: "white",
              paddingTop: "20px",
            }}
          >
            We are an equal opportunity employer and make employment decisions
            based on merit. We aim to have the best people in every job. Our
            policy prohibits unlawful discrimination based on race.
          </div>
          <div style={{ height: "50px" }} />
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Grid
              style={{
                width: state.auth.isMobile ? "100%" : "70%",
                display: "flex",
                justifyContent: "center",
              }}
              container
              spacing={3}
            >
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <FeatureCardSmall
                  title={"Remote or Office Work"}
                  text={""}
                  icon={
                    <WorkspacesIcon
                      style={{
                        fontSize: "50px",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Flexible Hours"}
                  text={""}
                  icon={
                    <AccessTimeIcon
                      style={{
                        fontSize: "50px",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Professional Development"}
                  text={""}
                  icon={
                    <SchoolIcon
                      style={{
                        fontSize: "50px",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>

              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Career Growth"}
                  text={""}
                  icon={
                    <TrendingUpIcon
                      style={{
                        fontSize: "50px",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
            </Grid>
          </div>
          <div style={{ height: "50px" }} />

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Grid
              style={{
                width: state.auth.isMobile ? "100%" : "70%",
                display: "flex",
                justifyContent: "center",
              }}
              container
              spacing={3}
            >
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <FeatureCardSmall
                  title={"Recognition and Rewards"}
                  text={""}
                  icon={
                    <EmojiEventsIcon
                      style={{
                        fontSize: "50px",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Team Activities"}
                  text={""}
                  icon={
                    <GroupsIcon
                      style={{
                        fontSize: "50px",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Parental Leave"}
                  text={""}
                  icon={
                    <ChildFriendlyIcon
                      style={{
                        fontSize: "50px",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
              <Grid
                item
                md={3}
                xs={10}
                sm={10}
                style={{
                  width: "100%",
                  textAlign: "left",
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                {" "}
                <FeatureCardSmall
                  title={"Health Benefits"}
                  text={""}
                  icon={
                    <HealthAndSafetyIcon
                      style={{
                        fontSize: "50px",
                        color: "white",
                        marginRight: "15px",
                      }}
                    />
                  }
                  gradient={
                    "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                  }
                />
              </Grid>
            </Grid>
          </div>

          <div style={{ height: "50px" }} />
        </div>

        <div style={{ display: state.auth.isMobile ? "none" : "block" }}>
          <Trust />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
